import { IconMapping } from "@/components/Sidebar/IconMapping";
import { NAV_MANIFEST } from "@/lib/navigation/nav-manifest";

/**
 * The icon the nav draws for a page, looked up by the page's href in
 * `lib/navigation/nav-manifest.js`. A page that shows a nav concept (the
 * home page's assignment rows) draws it with this, so it has the same icon
 * in a row as it has in the menu. The manifest picks the icon, so changing
 * it there changes it everywhere. `navigationManifest.test.js` checks that
 * every menu gives a label the same icon.
 */
const iconNameByHref = new Map();
const collect = (items) => {
  for (const item of items) {
    if (item.href && item.iconName && !iconNameByHref.has(item.href)) {
      iconNameByHref.set(item.href, item.iconName);
    }
    if (item.subItems) collect(item.subItems);
  }
};
NAV_MANIFEST.forEach((menu) => collect(menu.items));

export function getNavIcon(href) {
  const Icon = IconMapping[iconNameByHref.get(href)];
  if (!Icon) throw new Error(`No nav icon for ${href}`);
  return Icon;
}
